/* eslint-disable react/prop-types */
import { Skeleton, Tooltip } from '@mui/material'
import { ResponsiveTypography } from './styles'

/**
 * CustomCardContent is a React component that renders either a formatted amount or a Skeleton component based on the isLoading prop.
 * It also includes a Tooltip that displays the full amount when the amount exceeds 10 million.
 *
 * @param {Object} props - The component's props.
 * @param {boolean} props.isLoading - A boolean indicating whether the component is loading.
 * @param {number} props.amount - The amount to be displayed.
 *
 * @returns {JSX.Element} - The rendered component.
 */
function CustomCardContent({ isLoading, amount, ...rest }) {
  return !isLoading ? (
    <Tooltip placement="top" title={amount > 10000000 ? amount : null}>
      <ResponsiveTypography className="amount" variant="body1" mt=".5rem" noWrap {...rest}>
        {amount}
      </ResponsiveTypography>
    </Tooltip>
  ) : (
    <Skeleton data-testid="skeleton" width={100} height={45} variant="text" />
  )
}

export default CustomCardContent
